import { render } from "./siderBar.vue?vue&type=template&id=be1e95e6&scoped=true&lang=pug"
import script from "./siderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./siderBar.vue?vue&type=script&setup=true&lang=js"

import "./siderBar.vue?vue&type=style&index=0&id=be1e95e6&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1e95e6"]])

export default __exports__